import React from "react";
import { Link as ReactRouterLink, LinkProps } from "react-router-dom";
import { API_KEY_QUERY_PARAM_KEY, PROJECT_ID_QUERY_PARAM_KEY } from "./constants";

const queryParamsToPersist = [API_KEY_QUERY_PARAM_KEY, PROJECT_ID_QUERY_PARAM_KEY];

export const Link = (props: LinkProps) => {
    const newProps = { ...props };
    // eslint-disable-next-line react/destructuring-assignment
    if (typeof props.to === "string") {
        const [pathname, search] = props.to.split("?");
        const allSearchParams = new URLSearchParams(window.location.search);
        const searchParamsToKeep = new URLSearchParams(search);
        allSearchParams.forEach((val, name) => {
            if (queryParamsToPersist.includes(name)) {
                searchParamsToKeep.append(name, val);
            }
        });
        newProps.to = `${pathname}?${searchParamsToKeep.toString()}`;
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ReactRouterLink {...newProps} />;
};
